import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

export default function BookingChart({ data }) {
  const chartData = {
    labels: data?.map((item) => item?.name?.length > 15  ? item.name.slice(0, 10) + "..."  : item.name ) || [] ,
    datasets: [
      {
        data: data?.map((item) => item?.totalBookings) || [],
        backgroundColor: "#1d4ed8", // exact blue
        borderRadius: 8,
        barThickness: 10,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: "#94a3b8",
          callback: function (value) {
            return value ;
          },
        },
      },
      y: {
        grid: { display: false },
        ticks: { color: "#334155" },
      },
    },
  };

  return <div
    style={{
      height: `${Math.max(data?.length * 50, 180)}px`,
    }}
  ><Bar data={chartData} options={options} /></div>;
}